<template>
  <div class="container-faces">
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <div class="face-dente face-lingual" :class="{'face-selecionada' : faces.faceLingual}" v-on="on"/>
      </template>
      Lingual
    </v-tooltip>
    <div class="container-faces-meio">
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <div class="face-dente face-distal" :class="{'face-selecionada' : faces.faceDistal}" v-on="on"/>
        </template>
        Distal
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <div class="face-dente face-oclusal" :class="{'face-selecionada' : faces.faceOclusal}" v-on="on"/>
        </template>
        Oclusal
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <div class="face-dente face-mesial" :class="{'face-selecionada' : faces.faceMesial}" v-on="on"/>
        </template>
        Mesial
      </v-tooltip>
    </div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <div class="face-dente face-vestibular" :class="{'face-selecionada' : faces.faceVestibular}" v-on="on"/>
      </template>
      Vestibular
    </v-tooltip>
  </div>
</template>

<script>
export default {
    name: 'FacesDentesHistoricoItem',
    props: {
        faces: {
            type: Object,
            required: true
        },
    }
}
</script>

<style scoped lang="stylus">

.container-faces
  display flex
  flex-direction column
  align-items center

.container-faces-meio
  display flex
  flex-direction row

.face-dente
  height 15px
  width 20px
  background-color #e0e0e0
  border 1px solid black

.face-oclusal
  border none

.face-selecionada
  background-color var(--theme-secondary)

</style>